import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { _BaseApi } from "../../../base.api";
import { GrainBoxRollingTypes } from "../models/grain-box-rolling-types.model";

@Injectable()
export class GrainBoxRollingTypesApi extends _BaseApi {
    constructor(private http: HttpClient) {
        super("grain-box-rolling-type", http);
    }

    public getAll(): Observable<GrainBoxRollingTypes[]> {
        return this.get("", { type: GrainBoxRollingTypes });
    }
}
